import { isRequired } from "../services/utils";

const stickyMenu = () => {

    let scrollpos = window.scrollY;
    const breakpoint = {
        desktop: 1199
    }
    const isDesktop = window.innerWidth > breakpoint.desktop;
    const siteHeader = document.querySelector(".site-header");
    const isStruttura = siteHeader.classList.contains("--struttura");
    let initialSidebarBottom = 0; // Aggiungo variabile per memorizzare l'altezza iniziale
    
    /**
     * If the device is desktop, return the height of the desktop header, otherwise return the height
     * of the mobile header.
     * @param [device] - This is the device type. It can be either 'desktop' or 'mobile'.
     * @returns The height of the header.
     */
    const getHeaderHeight = ( device = isRequired() ) => {

        let headerDesktop = document.querySelector(".site-header--desktop .site-header__middle-bar");
        let headerMobile = document.querySelector(".site-header--mobile .site-header__middle-bar");
        let sharedSidebar = document.querySelector('.shared-sidebar.--sticky');

            if (sharedSidebar) {
                let height;

                switch (device) {
                    case 'desktop':
                        height = headerDesktop.offsetHeight;
                        break;

                    case 'mobile':
                        height = headerMobile.offsetHeight;
                        break;

                    default:
                        throw new Error('Invalid device type');
                }

                document.documentElement.style.setProperty('--headerHeight', `${height}px`);
                return height;
            }

        switch( device ) {
            case 'desktop' :
                return headerDesktop.offsetHeight;
            break;

            case 'mobile' :
                return headerMobile.offsetHeight;
            break;
        }
    }

    const add_class_on_scroll = () => siteHeader.classList.add("scrolled");
    const remove_class_on_scroll = () => siteHeader.classList.remove("scrolled");

    const strutturaSubnav = document.querySelector(".struttura-subsections-nav");
    
    let strutturaSubnavTop = 0;
    
    if(strutturaSubnav){
        /**
         * Se esiste submenu struttura:
         * calcola posizione ( scroll - altezza dell'header ) per sapere quando "tocca" il bottom
         */
        strutturaSubnavTop = strutturaSubnav.offsetTop - getHeaderHeight( isDesktop ? 'desktop' : 'mobile')
    }

    const stickyToggle = () => {
        const siteMain = document.querySelector('.site-main');
        const bannerPrenotazioni = document.querySelector('.banner-prenotazioni.--struttura');
        const bannerInfo = document.querySelector('.banner-prenotazioni.--info');
        const sharedSidebarInner = document.querySelector('.shared-sidebar__inner');
        const sharedSidebarSticky = document.querySelector('.shared-sidebar.--sticky');
        const breakpoint = {
            desktop: 1199
        };
        const isDesktop = window.innerWidth > breakpoint.desktop;
        scrollpos = window.scrollY;  

        // Calcola l'altezza iniziale solo se non è già stata calcolata
        if (initialSidebarBottom === 0 && sharedSidebarInner) {
            initialSidebarBottom = sharedSidebarInner.offsetTop + sharedSidebarInner.offsetHeight;
        }

        if (isDesktop && sharedSidebarInner && !sharedSidebarSticky) {  // Applica solo su desktop
            const activeBanner = bannerPrenotazioni || bannerInfo; // Usa il banner che è presente
            
            if (activeBanner) {
                const bannerHeight = activeBanner.offsetHeight;
        
                if (scrollpos >= initialSidebarBottom) {
                    // Aggiungi classe sticky quando scroll supera sharedSidebarInner
                    activeBanner.classList.add('--sticky');
                    activeBanner.style.top = `${getHeaderHeight('desktop')}px`; // Fai partire il banner dal fondo dell'header
                } else {
                    // Rimuovi classe sticky quando scroll è sopra sharedSidebarInner
                    activeBanner.classList.remove('--sticky');
                    activeBanner.style.top = 'auto';
                }
            }
        } else if(!isDesktop && sharedSidebarInner && !sharedSidebarSticky) {
            // Rimuovi eventuale classe sticky nel caso si ritorni a dimensioni mobile
            if (bannerPrenotazioni) bannerPrenotazioni.classList.remove('--sticky');
            if (bannerInfo) bannerInfo.classList.remove('--sticky');
        }

        /* Scroll orizzontale automatico alla voce active */
        if(strutturaSubnav){
            const activeSubnavMenu = document.querySelector('.struttura-subsections-nav .active')
            if(activeSubnavMenu){ //se trovo voce attiva scrollo
                const activeSubnavMenuLeft = activeSubnavMenu.offsetLeft;
                strutturaSubnav.scrollLeft = activeSubnavMenuLeft-15;
            }
        }
        if(isStruttura){
            if(scrollpos > 0){
                var height = siteHeader.offsetHeight;
                document.documentElement.style.setProperty('--headerHeight', `${height}px`);
                add_class_on_scroll();
                if(isDesktop ){ //desktop
                    siteMain.style.paddingTop = "142px";
                } else { // mobile (non ho topper-bar da 120)
                    siteMain.style.paddingTop = "120px";
                }

            } else { //se scrollpos = 0
                remove_class_on_scroll();
                siteMain.style.paddingTop = 0;
            }
        }else{
            if(isDesktop ){ //desktop
                
                if(!strutturaSubnav){
                    if (scrollpos > 36) { 
                        add_class_on_scroll();
                        siteMain.style.paddingTop = getHeaderHeight('desktop')+"px";
                    } else {
                        remove_class_on_scroll();
                        siteMain.style.paddingTop = 0;
                    }
                } else {
                    if(strutturaSubnav && scrollpos >= strutturaSubnavTop && scrollpos > 36){
                        add_class_on_scroll();
                        strutturaSubnav.style.top = getHeaderHeight('desktop')+"px";
                        siteMain.style.paddingTop = getHeaderHeight('desktop')+strutturaSubnav.offsetHeight+"px";
                        strutturaSubnav.classList.add('sticky');

                    } else if (strutturaSubnav && scrollpos < strutturaSubnavTop && scrollpos > 36) {
                        add_class_on_scroll();
                        siteMain.style.paddingTop = getHeaderHeight('desktop')+"px";
                        strutturaSubnav.classList.remove('sticky');
                        strutturaSubnav.style.top = 0;
                    } else { //se scrollpos = 0
                        remove_class_on_scroll();
                        siteMain.style.paddingTop = 0;
                    }
                }
            } else { // mobile (non ho topper-bar da 36)
                if(!strutturaSubnav){
                    if (scrollpos > 0) { 
                        add_class_on_scroll();
                        siteMain.style.paddingTop = getHeaderHeight('mobile')+"px";
                    } else {
                        remove_class_on_scroll();
                        siteMain.style.paddingTop = 0;
                    }
                } else {
                    if(strutturaSubnav && scrollpos >= strutturaSubnavTop && scrollpos > 0){
                        add_class_on_scroll();
                        strutturaSubnav.style.top = getHeaderHeight('mobile')+"px";
                        siteMain.style.paddingTop = getHeaderHeight('mobile')+strutturaSubnav.offsetHeight+"px";
                        strutturaSubnav.classList.add('sticky');

                    } else if (strutturaSubnav && scrollpos < strutturaSubnavTop && scrollpos > 0) {
                        add_class_on_scroll();
                        siteMain.style.paddingTop = getHeaderHeight('mobile')+"px";
                        strutturaSubnav.classList.remove('sticky');
                        strutturaSubnav.style.top = 0;
                    } else { //se scrollpos = 0
                        remove_class_on_scroll();
                        siteMain.style.paddingTop = 0;
                    }
                }
            }
        }
    }
    
    window.addEventListener('scroll', stickyToggle, false);
    window.addEventListener('load', stickyToggle, false);

    
}

export default stickyMenu;

